import React from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const HrAddIcon = ({ style }: { style?: any }) => (
    <AddCircleIcon fontSize="large" color="primary" sx={style} />
);

export default HrAddIcon;
